import React, { useRef } from "react";
import { Popover, IconButton } from "@mui/material";
import styled from "styled-components";

import { Icon } from "js/Components/Icon";
import { HoverHighlight } from "./HoverHighlight";

const CloseButtonContainer = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1000;
`;

const CloseButton = styled(IconButton)`
    &&& {
        padding: 8px;
    }
`;

const InstructionText = styled.div`
    font-family: "Source Sans Pro";
    font-size: 16px;
    font-style: italic;
    font-weight: 400;
    line-height: 125%;
    letter-spacing: -0.32px;
`;

const QuestionMarkIcon = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #E5E5E5;
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    color: #666666;
    margin: 0 4px;
    vertical-align: middle;
    line-height: 1;
    text-align: center;
    letter-spacing: 0;
`;

interface ExtraInfoMenuProps {
    open: boolean;
    onClose: () => void;
}

export const ExtraInfoMenu: React.FC<ExtraInfoMenuProps> = ({ open, onClose }) => {
    const instructionTextRef = useRef<HTMLDivElement>(null);

    if (!open) {
        return null;
    }

    return (
        <>
            <Popover
                open={open}
                onClose={onClose}
                disableEscapeKeyDown
                anchorReference="anchorPosition"
                // Match CompletedStep positioning (bottom-right near the ? icon)
                anchorPosition={{ top: window.innerHeight - 24, left: window.innerWidth - 82 }}
                transformOrigin={{
                    vertical: "bottom",
                    horizontal: "right"
                }}
                transitionDuration={0}
                PaperProps={{
                    style: {
                        width: 295,
                        background: "#FFFFFF",
                        borderRadius: 8,
                        boxShadow: "0 9px 37px 0 rgba(0, 0, 0, 0.20)",
                        border: "1px solid #222",
                        padding: 16,
                        position: "relative",
                        zIndex: 10
                    }
                }}
                disableRestoreFocus
                disableEnforceFocus
                disableAutoFocus
            >
                <CloseButtonContainer>
                    <CloseButton onClick={onClose} size="small" aria-label="Close">
                        <Icon color="#000000" large>close</Icon>
                    </CloseButton>
                </CloseButtonContainer>
                <InstructionText ref={instructionTextRef}>
                    To revisit this helpful checklist, find it under the <QuestionMarkIcon>?</QuestionMarkIcon> icon.
                </InstructionText>
            </Popover>
            <HoverHighlight
                target="#help-icon"
                hoverTriggerRef={instructionTextRef}
            />
        </>
    );
};

